import { resolveApiBaseUrl, resolveUploadUrl } from './apiBase';

const API_BASE_URL = resolveApiBaseUrl();

export const absoluteUrl = (val) => resolveUploadUrl(val) || val || '';

export const fetchProducts = async ({ page = 1, limit = 50, category, search, featured } = {}) => {
  try {
    let url = `${API_BASE_URL}/api/products?page=${page}&limit=${limit}`;
    if (category && category !== 'all') url += `&category=${encodeURIComponent(category)}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    if (featured) url += `&featured=1`;

    const res = await fetch(url, { cache: 'no-store' });
    if (!res.ok) return [];
    const data = await res.json();
    if (!data.success || !Array.isArray(data.data)) return [];
    return data.data
      .map(transformProductToFrontendShape)
      .filter(Boolean);
  } catch (error) {
    console.error('Products fetch error:', error);
    throw error;
  }
};

export const fetchProductBySlug = async (slug) => {
  const url = `${API_BASE_URL}/api/products/slug/${encodeURIComponent(slug)}`;
  const res = await fetch(url, { cache: 'no-store' });
  if (!res.ok) return null;
  const data = await res.json();
  if (!data.success || !data.data) return null;
  return transformProductToFrontendShape(data.data);
};

export const fetchProductById = async (id) => {
  const url = `${API_BASE_URL}/api/products/${encodeURIComponent(id)}`;
  const res = await fetch(url, { cache: 'no-store' });
  if (!res.ok) return null;
  const data = await res.json();
  if (!data.success || !data.data) return null;
  return transformProductToFrontendShape(data.data);
};

export const fetchProductCategories = async () => {
  try {
    const url = `${API_BASE_URL}/api/products/categories`;
    const res = await fetch(url, { cache: 'no-store' });
    if (!res.ok) return [];
    const data = await res.json();
    if (!data.success || !Array.isArray(data.data)) return [];
    return data.data;
  } catch {
    return [];
  }
};

export const formatStatisticLine = (stat) => {
  if (!stat) return '';
  const value = (stat.value || '').trim();
  const label = (stat.label || '').trim();
  if (value && label) return `${value} ${label}`;
  return value || label;
};

export const transformProductToFrontendShape = (item) => {
  if (!item) return null;
  try {
    const features = Array.isArray(item.features) ? item.features : [];
    const statistics = Array.isArray(item.statistics) ? item.statistics : [];
    const galleryImages = Array.isArray(item.gallery_images) ? item.gallery_images : [];

    return {
      id: item.id,
      slug: item.slug || '',
      title: item.title || 'Untitled',
      category: item.category || '',
      heroTitle: item.hero_title || item.title || '',
      heroSubtitle: item.hero_subtitle || '',
      shortDescription: item.short_description || '',
      longDescription: item.long_description || '',
      features: features.map((f) => (typeof f === 'string' ? f : f.text)).filter(Boolean),
      statistics: statistics.map((s) => ({
        value: s.value || '',
        label: s.label || '',
        line: formatStatisticLine(s)
      })),
      galleryImages: galleryImages.map((g) => ({
        path: absoluteUrl(g.path),
        alt: g.alt || '',
        isCover: Boolean(g.isCover)
      })),
      heroImage: absoluteUrl(item.hero_image),
      heroImageAlt: item.hero_image_alt || item.title || '',
      thumbnail: absoluteUrl(item.thumbnail || item.hero_image),
      bannerImage: absoluteUrl(item.banner_image),
      btnText: item.btn_text || 'Contact With Us',
      btnLink: item.btn_link || '/contact',
      imagePosition: item.image_position || 'left',
      displayOrder: item.display_order ?? 0,
      featured: Boolean(item.featured),
      status: item.status || 'published',
      metaTitle: item.meta_title || item.title || '',
      metaDescription: item.meta_description || item.short_description || '',
      metaKeywords: item.meta_keywords || '',
      ogImage: absoluteUrl(item.og_image || item.hero_image),
      canonicalUrl: item.canonical_url || ''
    };
  } catch (error) {
    console.error('Error transforming product:', error, item);
    return null;
  }
};
